/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */

export {compileLitTemplates} from './lib/template-transform.js';
